import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { formatAsTimeAgo } from '../../helpers/date';
var RubriqAbstractCardStatus = function RubriqAbstractCardStatus(_ref) {
  var abstract = _ref.abstract;
  var currentStage = abstract.currentStage,
    createdAt = abstract.createdAt;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center rubriq-text-document-status"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: currentStage
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, "\xB7", /*#__PURE__*/React.createElement("span", null, formatAsTimeAgo(createdAt, t))));
};
export default RubriqAbstractCardStatus;